import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plusSign",
  "use": "icon-plusSign-usage",
  "viewBox": "0 0 15.1250012 15.125",
  "content": "<symbol viewBox=\"0 0 15.1250012 15.125\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-plusSign\">\n    <title>联集 7</title>\n    <g id=\"icon-plusSign_工单系统\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\">\n        <g id=\"icon-plusSign_新建工单\" transform=\"translate(-485.9375, -525.9375)\" fill=\"#FFFFFF\" fill-rule=\"nonzero\" stroke=\"#FFFFFF\" stroke-width=\"2\">\n            <path d=\"M486.9375,533.5 L500.0625,533.6 M493.500916,526.9375 L493.500916,535.538599 L493.500916,540.0625\" id=\"icon-plusSign_联集-7\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/plusSign.svg
// module id = gCOZ
// module chunks = 102